import gql from 'graphql-tag';

export const DELETE_DEPARTMENT = gql`
  mutation DeleteDepartment($input: DeleteDepartmentInput!) {
    bpf {
      result: deleteDepartment(input: $input) {
        error
        success
        entity {
          id
        }
      }
    }
  }
`;
